import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import withRouter from 'shared/hoc/withRouter';
import AuthService from 'shared/services/auth.service';
import { createAction } from 'shared/util/utility';
import { Action, RouteComponentParams, State } from 'shared/interface';
import PermissionManager from 'shared/hoc/permission/permissionManager';
import { PermissionList } from 'shared/interface/enum';
import { LoginResponse } from 'features/login/interface/login.interface';
import * as ProfileActions from 'features/login/store/login.action';
import * as actionTypes from 'store/action-types';
import NavItem from './navItem';

interface DispatchProps {
	renderSideNav: () => void;
	getProfile: () => void;
}
interface UIState {
	openStatus: {
		[key: string]: boolean;
	};
}
interface OwnProps extends State, DispatchProps, RouteComponentParams {}

class SideNav extends PureComponent<OwnProps> {
	state: UIState = {
		openStatus: {}
	};

	render() {
		if (!this.props.auth.authData.auth) {
			return <Navigate replace to="/login" />;
		}

		const userData = AuthService.getAuthData() as LoginResponse;
		return (
			<nav className="navbar-default navbar-static-side" role="navigation">
				<ul className="nav" id="side-menu">
					<li className="nav-header cursor-pointer">
						<h3 className="profile-element">ADMIN</h3>
						<span className="user-role-element text-muted text-xs block">
							{!!userData ? userData.displayName : 'Admin'}
						</span>
						<div className="logo-element">FB</div>
					</li>
					<PermissionManager permission={[PermissionList.DashboardView]}>
						<NavItem
							isOpen={this.state.openStatus.Dashboard || false}
							toggleIsOpen={this.toggleIsOpen}
							key={'Dashboard'}
							renderSideNav={this.props.renderSideNav}
							menu={{
								name: 'Dashboard',
								route: '/dashboard',
								icon: 'dashboard',
								children: [
									{ name: 'Aggregated', url: '/dashboard/aggregated' },
									{ name: 'Daywise', url: '/dashboard/daywise' },
									{ name: 'Monthly', url: '/dashboard/monthly' },
									{ name: 'Exclusive', url: '/dashboard/exclusive' }
								]
							}}
						/>
					</PermissionManager>
					<NavItem
						isOpen={this.state.openStatus.Events || false}
						toggleIsOpen={this.toggleIsOpen}
						key={'Creators'}
						renderSideNav={this.props.renderSideNav}
						menu={{ name: 'Creators', route: '/creators', icon: 'events' }}
					/>
					<PermissionManager permission={[PermissionList.FanUserList]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Fan Users"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Fan Users', route: '/fan-users', icon: 'userValue' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Payment list"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Payments', route: '/payment-list', icon: 'transaction' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.CreditNotesList]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Credit Notes"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Credit Notes', route: '/credit-notes', icon: 'transaction' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.BillingView]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Subscriptions"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Subscriptions', route: '/subscriptions', icon: 'transaction' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Payment User Values"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Payment User Values', route: '/payment-user-values', icon: 'userValue' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Webhook Logs"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Webhook Logs', route: '/webhook-logs', icon: 'list' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.UserList]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key={'Users'}
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Admin Users', route: '/users', icon: 'users' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.RolesList]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Roles"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Admin Roles', route: '/roles', icon: 'userSecret' }}
						/>
					</PermissionManager>
					<PermissionManager anyOnePermission={[PermissionList.TelegramGroupList, PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Conversations || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Conversations"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Conversations', route: '/conversations', icon: 'chat' }}
						/>
					</PermissionManager>
					<PermissionManager
						anyOnePermission={[
							PermissionList.AiConversationList,
							PermissionList.AiConversationGet,
							PermissionList.AiConversationAsk,
							PermissionList.FullAccess
						]}
					>
						<NavItem
							isOpen={this.state.openStatus['AI Assistant'] || false}
							toggleIsOpen={this.toggleIsOpen}
							key="AI Assistant"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'AI Assistant', route: '/ai-assistant', icon: 'magic' }}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.BMMaster]}>
						<NavItem
							isOpen={this.state.openStatus['Messaging Config'] || false}
							toggleIsOpen={this.toggleIsOpen}
							key={'Messaging Config'}
							renderSideNav={this.props.renderSideNav}
							menu={{
								name: 'Messaging Config',
								route: '/messaging-config',
								icon: 'chat',
								children: [
									{ name: 'Business Managers', url: '/messaging-config/bm' },
									{ name: 'Creators', url: '/messaging-config/creators' },
									{ name: 'Twilio Accounts', url: '/messaging-config/twilio' }
								]
							}}
						/>
					</PermissionManager>
					<PermissionManager permission={[PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="App Configuration"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'App Configuration', route: '/app-config', icon: 'setting' }}
						/>
					</PermissionManager>
					{!!userData && (
						<>
							{/* <PermissionManager permission={[PermissionList.EnergyPackageList]}>
								<NavItem
									isOpen={this.state.openStatus.Shop || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'Shop'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Shop', route: '/shop', icon: 'shop' }}
								/>
							</PermissionManager>
							<PermissionManager permission={[PermissionList.BonusList]}>
								<NavItem
									isOpen={this.state.openStatus.Users || false}
									toggleIsOpen={this.toggleIsOpen}
									key="Add Bonus"
									renderSideNav={this.props.renderSideNav}
									menu={{
										name: 'Creator Bonus',
										route: '/add-bonus',
										icon: 'addBonus'
									}}
								/>
							</PermissionManager>
							<PermissionManager permission={[PermissionList.SmsPackageList]}>
								<NavItem
									isOpen={this.state.openStatus.Shop || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'SmsPackage'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Campaign Sms', route: '/sms-package', icon: 'smsPackage' }}
								/>
							</PermissionManager> */}
							{/* <PermissionManager permission={[PermissionList.EarlyAccessGet]}>
								<NavItem
									isOpen={this.state.openStatus.EarlyAccess || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'EarlyAccess'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Early Access', route: '/early-access', icon: 'earlyAccess' }}
								/>
							</PermissionManager> */}
							{/* <PermissionManager permission={[PermissionList.ReferUrlList]}>
								<NavItem
									isOpen={this.state.openStatus.Users || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'Refer URL'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Refer URL', route: '/refer-url', icon: 'link' }}
								/>
							</PermissionManager> */}
							{/* <PermissionManager permission={[PermissionList.ExploreAll]}>
								<NavItem
									isOpen={this.state.openStatus.Users || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'Explore'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Explore page', route: '/explore', icon: 'sort' }}
								/>
							</PermissionManager> */}
							{/* <PermissionManager permission={[PermissionList.CreatorConfigPlanList]}>
								<NavItem
									isOpen={this.state.openStatus.Users || false}
									toggleIsOpen={this.toggleIsOpen}
									key={'Plans'}
									renderSideNav={this.props.renderSideNav}
									menu={{ name: 'Subscription Plans', route: '/subscriptionPlans', icon: 'list' }}
								/>
							</PermissionManager> */}
						</>
					)}
					{/* <PermissionManager permission={[PermissionList.ChatModeratorGetCreatorAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key={'Support Chat'}
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Support Chat', route: '/support-chat', icon: 'chat' }}
						/>
					</PermissionManager> */}
					{/* <PermissionManager permission={[PermissionList.BanAndUnBanUserList]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Banned Users"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Banned Users', route: '/unban-users', icon: 'ban' }}
						/>
					</PermissionManager> */}
					{/* <PermissionManager permission={[PermissionList.PayoutsGet]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Payout"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Payout', route: '/payout', icon: 'money' }}
						/>
					</PermissionManager> */}
					{/* <PermissionManager permission={[PermissionList.CreatorPayment]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Transaction"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Creator Purchase', route: '/transaction', icon: 'transaction' }}
						/>
					</PermissionManager>
					<PermissionManager
						anyOnePermission={[
							PermissionList.FanPaymentEnergyList,
							PermissionList.FanPaymentVipList,
							PermissionList.FanPaymentDirectPurchaseList,
							PermissionList.FanPaymentSuperSmsList,
							PermissionList.FanPaymentTipList,
							PermissionList.FanPaymentAllList,
							PermissionList.FanPaymentSignUpList
						]}
					>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Fan Transaction"
							renderSideNav={this.props.renderSideNav}
							menu={{
								name: 'Fan Purchase',
								route: '/fan-transaction',
								icon: 'fanTransaction'
							}}
						/>
					</PermissionManager> */}
					{/* <PermissionManager permission={[PermissionList.FullAccess]}>
						<NavItem
							isOpen={this.state.openStatus.Users || false}
							toggleIsOpen={this.toggleIsOpen}
							key="Available Numbers"
							renderSideNav={this.props.renderSideNav}
							menu={{ name: 'Available Numbers', route: '/available-numbers', icon: 'phone' }}
						/>
					</PermissionManager> */}
				</ul>
			</nav>
		);
	}
	toggleIsOpen = (name: string) => {
		if (this.state.openStatus[name]) {
			this.setState({
				openStatus: {}
			});
		} else {
			this.setState({
				openStatus: {
					[name]: true
				}
			});
		}
	};
}

const mapStateToProps = (state: State): State => {
	return state;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, Action>): DispatchProps => {
	return {
		/**
		 * renderSideNav - render side nav on side nav click, in order to change active tag of navigation-item
		 * when navigating from one route to another, if in any case, there isn't any action dispatch
		 * (in case if we have data in store, and we don't call API)
		 * then, store won't change, and sidenNav won't get rerendered
		 * we it's necessary to rerender sidenav, on route change, in order to update active route link
		 * renderSideNav is used to dispatch NO_ACTION, which will rerender this component
		 */
		renderSideNav: () => dispatch(createAction(actionTypes.NO_ACTION)),
		getProfile: () => dispatch(ProfileActions.getProfile())
	};
};

export default connect<State, DispatchProps, {}, State>(mapStateToProps, mapDispatchToProps)(withRouter(SideNav));
